import { Component } from '@angular/core';
import { ColumnActionIconsDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-action-icons',
  styleUrls: ['./ap-column-action-icons.component.less'],
  templateUrl: './ap-column-action-icons.component.html',
})
export class ApColumnActionIconsComponent extends ApColumnBase<ColumnActionIconsDto> {
  load() {
    return;
  }
}
